module.exports = __webpack_public_path__ + "k-icons.1616798053864.svg";